// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDAvatar from 'components/MDAvatar';
import MDBadge from 'components/MDBadge';
import DisplayNote from 'components/General/Note/DisplayNote';
// Images
import orderImage from 'assets/images/product-12.jpg';

// React hooks

function OrderInfo({ line_items }) {
    // Null/undefined kontrolü
    if (!line_items || !Array.isArray(line_items) || line_items.length === 0) {
        return (
            <MDBox textAlign="center" py={3}>
                <MDTypography variant="h6" color="text">
                    Sipariş kalemleri bulunamadı
                </MDTypography>
            </MDBox>
        );
    }

    // Fiyat formatlama fonksiyonu
    const formatPrice = (price) => {
        try {
            const numericPrice = parseFloat(price) || 0;
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
            }).format(numericPrice);
        } catch (error) {
            console.warn('Fiyat formatlama hatası:', error);
            return '0,00 ₺';
        }
    };

    // Gösterilmeyecek meta data keylerinin listesi
    const excludedMetaKeys = [
        '_pao_total',
        '_reduced_stock',
        '_price_including_tax',
        '_price_excluding_tax',
        // Başka gizlenmesi gereken meta datalar buraya eklenebilir
    ];

    // Meta data'yı filtreleme ve düzenleme
    const getDisplayableMetaData = (metaData) => {
        if (!metaData || !Array.isArray(metaData)) return [];

        return metaData.filter(
            (meta) =>
                meta &&
                !excludedMetaKeys.includes(meta.key) &&
                meta.display_key &&
                meta.display_value &&
                typeof meta.display_value === 'string'
        );
    };

    return (
        <>
            <Grid container spacing={3}>
                {line_items.map((item, index) => {
                    // Item güvenlik kontrolü
                    if (!item) return null;

                    const itemId = item.id || `item-${index}`;
                    const itemName = item.name || 'Ürün Adı Belirtilmemiş';
                    const itemQuantity = parseInt(item.quantity) || 1;
                    const itemPrice = parseFloat(item.price) || 0;
                    const itemSubtotalTax = parseFloat(item.subtotal_tax) || 0;

                    return (
                        <Grid key={itemId} size={{ xs: 12 }}>
                            <MDBox
                                sx={{
                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        boxShadow:
                                            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                                        transform: 'translateY(-4px)',
                                        borderColor: '#10B981',
                                    },
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        height: '4px',
                                        background: 'linear-gradient(90deg, #10B981, #059669)',
                                        borderRadius: '16px 16px 0 0',
                                    },
                                }}
                            >
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{
                                        alignItems: 'center',
                                    }}
                                >
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 9,
                                        }}
                                    >
                                        <MDBox display="flex" alignItems="center">
                                            <MDBox
                                                mr={3}
                                                sx={{
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                }}
                                            >
                                                <MDAvatar
                                                    size="xl"
                                                    src={item.image?.src || orderImage}
                                                    alt={itemName}
                                                    sx={{
                                                        border: '3px solid #e2e8f0',
                                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            borderColor: '#10B981',
                                                            transform: 'scale(1.05)',
                                                        },
                                                    }}
                                                />
                                                {/* Quantity badge */}
                                                <MDBox
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '-8px',
                                                        right: '-8px',
                                                        backgroundColor: '#10B981',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '24px',
                                                        height: '24px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '0.75rem',
                                                        fontWeight: 'bold',
                                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                    }}
                                                >
                                                    {itemQuantity}
                                                </MDBox>
                                            </MDBox>
                                            <MDBox lineHeight={1} flex={1}>
                                                <MDTypography
                                                    variant="h6"
                                                    fontWeight="medium"
                                                    sx={{
                                                        color: '#1f2937',
                                                        marginBottom: '8px',
                                                        fontSize: '1.1rem',
                                                    }}
                                                >
                                                    {itemName}
                                                </MDTypography>

                                                {/* Meta data gösterimi */}
                                                {item.meta_data && item.meta_data.length > 0 && (
                                                    <MDBox mb={2}>
                                                        {getDisplayableMetaData(item.meta_data).map(
                                                            (meta, metaIndex) => (
                                                                <MDBox
                                                                    key={`meta-${metaIndex}`}
                                                                    sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        marginBottom: '4px',
                                                                        padding: '6px 10px',
                                                                        backgroundColor: '#eff6ff',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #bfdbfe',
                                                                    }}
                                                                >
                                                                    <MDBox
                                                                        sx={{
                                                                            width: '6px',
                                                                            height: '6px',
                                                                            backgroundColor: '#3B82F6',
                                                                            borderRadius: '50%',
                                                                            marginRight: '8px',
                                                                        }}
                                                                    />
                                                                    <MDTypography
                                                                        variant="caption"
                                                                        sx={{
                                                                            color: '#1e40af',
                                                                            fontWeight: '600',
                                                                            fontSize: '0.75rem',
                                                                        }}
                                                                    >
                                                                        {meta.display_key}: {meta.display_value}
                                                                    </MDTypography>
                                                                </MDBox>
                                                            )
                                                        )}
                                                    </MDBox>
                                                )}

                                                {/* SKU Bilgisi */}
                                                {item.sku && (
                                                    <MDBox
                                                        sx={{
                                                            display: 'inline-block',
                                                            backgroundColor: '#f3f4f6',
                                                            border: '1px solid #d1d5db',
                                                            borderRadius: '8px',
                                                            padding: '6px 12px',
                                                            marginTop: '8px',
                                                        }}
                                                    >
                                                        <MDTypography
                                                            variant="caption"
                                                            sx={{
                                                                color: '#6b7280',
                                                                fontWeight: '600',
                                                                fontSize: '0.75rem',
                                                            }}
                                                        >
                                                            SKU: {item.sku}
                                                        </MDTypography>
                                                    </MDBox>
                                                )}
                                            </MDBox>
                                        </MDBox>
                                    </Grid>
                                    <Grid
                                        sx={{ textAlign: 'right' }}
                                        size={{
                                            xs: 12,
                                            md: 3,
                                        }}
                                    >
                                        <MDBox
                                            sx={{
                                                backgroundColor: '#f8fafc',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: '12px',
                                                padding: '16px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <MDBox display="flex" justifyContent="center" alignItems="baseline" mb={1}>
                                                <MDTypography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#6b7280',
                                                        marginRight: '4px',
                                                        fontSize: '0.75rem',
                                                    }}
                                                >
                                                    {itemQuantity} adet ×
                                                </MDTypography>
                                                <MDTypography
                                                    variant="h5"
                                                    sx={{
                                                        color: '#10B981',
                                                        fontWeight: '700',
                                                        fontSize: '1.25rem',
                                                    }}
                                                >
                                                    {formatPrice(itemPrice)}
                                                </MDTypography>
                                            </MDBox>

                                            {itemQuantity > 1 && (
                                                <MDBox
                                                    sx={{
                                                        backgroundColor: '#fef3c7',
                                                        border: '1px solid #f59e0b',
                                                        borderRadius: '6px',
                                                        padding: '4px 8px',
                                                        marginBottom: '8px',
                                                    }}
                                                >
                                                    <MDTypography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#d97706',
                                                            fontWeight: '600',
                                                            fontSize: '0.7rem',
                                                        }}
                                                    >
                                                        ⚠️ Miktara dikkat
                                                    </MDTypography>
                                                </MDBox>
                                            )}

                                            {itemSubtotalTax > 0 && (
                                                <MDBox
                                                    sx={{
                                                        backgroundColor: '#f3f4f6',
                                                        borderRadius: '6px',
                                                        padding: '4px 8px',
                                                    }}
                                                >
                                                    <MDTypography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#6b7280',
                                                            fontSize: '0.7rem',
                                                        }}
                                                    >
                                                        Vergi: {formatPrice(itemSubtotalTax)}
                                                    </MDTypography>
                                                </MDBox>
                                            )}
                                        </MDBox>
                                    </Grid>
                                </Grid>
                                <DisplayNote relatedID={itemId} />
                            </MDBox>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
}

export default OrderInfo;
